export const SUPER_ADMIN_EMAILS = ["randycobela@gmail.com", "randy@rycso.es"] as const;

export function normalizeEmail(email: string | null | undefined): string {
  return String(email || "")
    .trim()
    .toLowerCase();
}

export function isSuperAdminEmail(email: string | null | undefined): boolean {
  const key = normalizeEmail(email);
  return (SUPER_ADMIN_EMAILS as readonly string[]).includes(key);
}
